import React, { useState } from "react";
import { faqItems } from "../../data/mockData";
import { ChevronDown } from "lucide-react";

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="resources" className="py-28">
      <div className="max-w-[700px] mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-white/[0.03] border border-white/[0.07] rounded-full px-4 py-1.5 mb-6">
            <span className="text-[11px] text-[#7a7a7a] uppercase tracking-widest font-medium">FAQ</span>
          </div>
          <h2 className="text-3xl md:text-[2.75rem] font-bold text-white tracking-[-0.02em] leading-tight">
            Questions? Answers.
          </h2>
        </div>

        <div className="space-y-2">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-xl border border-white/[0.06] bg-[#0a0a0c] overflow-hidden transition-colors duration-300 hover:border-white/[0.1]"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between p-5 text-left"
              >
                <span className="text-[15px] text-white/90 font-medium pr-4">{item.question}</span>
                <ChevronDown
                  size={18}
                  className={`text-white/30 shrink-0 transition-transform duration-300 ${
                    openIndex === i ? "rotate-180" : ""
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? "max-h-48 pb-5" : "max-h-0"
                }`}
              >
                <p className="px-5 text-[14px] text-[#666] leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
